import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class ProveedoresService extends ApiService {
  entityType = EntityType.PROVEEDOR;
  url = 'api/proveedores/';
}
